import { TrackerTag } from '@/types/tracking';

export const overlayClassName: string =
  'fixed bg-gray-1100 bg-opacity-50 inset-0 z-20 flex justify-center items-center';
export const getSessionStorageName = (value: string) => `__${value}`;

export const CCP_KEY: any = 'CookieFirst';
export const AttributionTrackingCookiePrefix: string = 'attribution_';

export const AttributionTrackingTags: TrackerTag[] = [
  {
    key: 'registrationSource',
    tags: ['source', 'refId'],
    cookieConsentPolicies: ['functional'], // Options: advertising, functional, necessary, performance
    cookieExpiryDays: 30
  }
];
